// extracted by mini-css-extract-plugin
export var problems = "problems-module--problems--af665";
export var problems__col = "problems-module--problems__col--5a445";
export var problems__item = "problems-module--problems__item--676fc";
export var problems__itemFirst = "problems-module--problems__item--first--8d89c";
export var problems__itemSecond = "problems-module--problems__item--second--09755";
export var problems__row = "problems-module--problems__row--32273";
export var problems__title = "problems-module--problems__title--fd6e8";